import React from 'react';
import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import type { ProfileCardDefinition } from '#components/ProfileCard';
import ProfileCard from '#components/ProfileCard';
import useViewport from '#hooks/useViewport';

export type PersonCardProps = Pick<ProfileCardDefinition, 'photo' | 'slug'>
& {
  name: ProfileCardDefinition['title'],
  jobTitle: ProfileCardDefinition['subtitle'],
  profilePage?: {
    composePage: {
      slug: string,
    }[]
  }[],
};

const translationKey = 'Components.PersonCard';

const PersonCard = ({
  name,
  jobTitle,
  photo,
  profilePage,
  slug,
}: PersonCardProps) => {
  const { t } = useTranslation();
  const mobileViewports = ['xs', 'sm', 'md'];
  const isMobile = mobileViewports.includes(useViewport());

  return (
    <ProfileCard
      photo={photo}
      title={name}
      subtitle={jobTitle}
      slug={profilePage?.[0]?.composePage?.[0]?.slug ?? slug}
      showPhoto
      showButton
      buttonLabel={t(`${translationKey}.ReadBio`) ?? 'Read Bio'}
      buttonVariant="bio"
      cardSx={{
        minHeight: 'auto',
        width: isMobile ? '100%' : '240px',
        transform: isMobile ? 'scale(1.2)' : 'scale(1)',
      }}
      cardActionSx={{ mt: 0 }}
      removeReveal
      gatsbyImageStyle={{
        height: isMobile ? 100 : 185,
        width: isMobile ? 100 : 185,
      }}
      contentSx={{
        marginTop: !isMobile && !isEmpty(photo) ? 13 : 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
      mobileLayout={isMobile}
    />
  );
};

export default PersonCard;
